#import '../fragments/email-sequence-template-stub-fragment.graphql'

query GetEmailTemplateGroups(
    $creatorIds: [ID!]
    $onlyArchived: Boolean
    $includeShared: Boolean
    $search: String
    $includeUnsharedFromOthers: Boolean
) {
    emailSequenceTemplateGroups {
        groups {
            id
            name
            position
            canRename
            canArchive
            emailSequenceTemplates(
                creatorIds: $creatorIds
                onlyArchived: $onlyArchived
                includeShared: $includeShared
                search: $search
                includeUnsharedFromOthers: $includeUnsharedFromOthers
            ) {
                ...EmailSequenceTemplateStubFragment
            }
        }
        uncategorized(
            creatorIds: $creatorIds
            onlyArchived: $onlyArchived
            includeShared: $includeShared
            search: $search
            includeUnsharedFromOthers: $includeUnsharedFromOthers
        ) {
            ...EmailSequenceTemplateStubFragment
        }
        recentlySent {
            ...EmailSequenceTemplateStubFragment
        }
    }
}
